// MLS-AUTO-FINALIZE-001 — user feedback for the automatic ORDER completion that runs when the last
// dual component completes (payload: `order_completion` on POST /components/{c}/complete).
import React from 'react';
import { toast } from 'sonner';

const reasonOf = (detail) => {
  if (!detail) return 'Unknown reason';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail.validation_errors) && detail.validation_errors.length) return detail.validation_errors.join('; ');
  return detail.message || detail.error || JSON.stringify(detail);
};

const deliveryLine = (oc) => {
  const ds = oc.delivery_status;
  if (ds === 'sending' || ds === 'sent') return `Emailing the merged PDF to ${oc.delivery_recipient}.`;
  if (ds === 'portal_upload_required') return 'Client uses an external portal — upload the merged PDF from Files.';
  return 'No delivery email is configured for this client code — the merged PDF is in Files and the order is flagged for delivery follow-up.';
};

/** Returns true when the page will reload (order finalized / routed to QC). */
export const notifyOrderCompletion = (oc) => {
  if (!oc) return false;
  if (oc.status === 'completed' || oc.status === 'already_complete') {
    toast.success(
      <div data-testid="mls-order-auto-completed-toast">
        <strong>Both components complete — order finalized.</strong>
        {oc.final_pdf_filename && <div style={{ fontSize: 12, marginTop: 4 }}>{oc.final_pdf_filename}</div>}
        <div style={{ fontSize: 12, marginTop: 4 }}>{deliveryLine(oc)}</div>
      </div>, { duration: 10000 });
    setTimeout(() => window.location.reload(), 2500);
    return true;
  }
  if (oc.status === 'qc_review') {
    toast.success('Both components complete — order routed to QC review. The client package is emailed on QC approval.', { duration: 8000 });
    setTimeout(() => window.location.reload(), 2500);
    return true;
  }
  if (oc.status === 'blocked') {
    toast.warning(
      <div data-testid="mls-order-auto-completion-blocked-toast">
        <strong>Component completed, but the order could not be finalized automatically.</strong>
        <div style={{ fontSize: 12, marginTop: 4 }}>{reasonOf(oc.detail)}</div>
        <div style={{ fontSize: 12, marginTop: 4 }}>Resolve the issue, then use Complete in Workflow Actions.</div>
      </div>, { duration: 12000 });
  }
  return false;
};
